import { render, staticRenderFns } from "./xx-img.vue?vue&type=template&id=46759b92&scoped=true&"
import script from "./xx-img.vue?vue&type=script&lang=js&"
export * from "./xx-img.vue?vue&type=script&lang=js&"
import style0 from "./xx-img.vue?vue&type=style&index=0&id=46759b92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46759b92",
  null
  
)

export default component.exports